import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import OfferBar from './OfferBar';

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #505050; /* another light purple shade */
  padding: 0.5rem 1rem;
  z-index: 100;
  position: relative;
  width: 100%;
//   height: 7vh;
`;

const NavWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  z-index: 100;
  width: 100%;
`;

const Brand = styled.div`
  font-family: 'Qwitcher Grypen', cursive;
  font-size: 2rem;
//   color: #800020; /* maroon text */
`;

const NavLinks = styled.div`
  a {
    margin-left: 2rem;
    text-decoration: none;
    color: #ffffff;
    font-family: 'Playfair Display SC', serif;
    font-size: 1.1rem;

    &:hover {
      opacity: 0.7;
    }
  }
`;

function Navbar() {
  return (
    <NavWrapper>
        <OfferBar />
        <Nav>
        {/* <Brand>CustomCarats</Brand> */}
        <img src='/CustomCaratsLogoLarge.png'  style={{height: '6vh', paddingLeft: '2%', filter: 'invert(100%)'}}/>
        <NavLinks>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/portfolio">Example Portfolio</Link>
        </NavLinks>
        </Nav>
    </NavWrapper>
  );
}

export default Navbar;
